<template>
    <div class="flex flex-col lg:flex-row gap-4">
        <!-- Quick Period Selector -->
        <div class="flex items-center gap-3">
            <div class="flex gap-2 flex-wrap">
                <Button v-for="option in quickPeriodOptions" :key="option.value" :label="option.label"
                    :severity="selectedQuickPeriod === option.value ? 'primary' : ''"
                    :outlined="selectedQuickPeriod !== option.value" @click="handleQuickPeriodChange(option.value)" />
            </div>
        </div>

        <!-- Date Range Picker -->
        <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3">
            <label class="font-semibold shrink-0">{{ t('maintenance.period.selectRange') }}</label>
            <DatePicker v-model="localDateRange" selectionMode="range" dateFormat="dd/mm/yy" showIcon
                iconDisplay="input" :showButtonBar="true" class="w-full sm:flex-1 sm:max-w-md"
                @update:modelValue="handleDateRangeChange">
                <template #inputicon="slotProps">
                    <i class="fa-regular fa-calendar"></i>
                </template>
            </DatePicker>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

interface Props {
    dateRange: Date[];
    selectedQuickPeriod: string;
    quickPeriodOptions: Array<{ label: string; value: string }>;
}

interface Emits {
    (e: 'update:dateRange', value: Date[]): void;
    (e: 'update:selectedQuickPeriod', value: string): void;
    (e: 'applyQuickPeriod'): void;
    (e: 'dateRangeChange'): void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();
const { t } = useI18n();

const localDateRange = ref<Date[]>([...props.dateRange]);

watch(() => props.dateRange, (newValue) => {
    localDateRange.value = [...newValue];
}, { deep: true });

function handleQuickPeriodChange(value: string) {
    emit('update:selectedQuickPeriod', value);
    emit('applyQuickPeriod');
}

function handleDateRangeChange() {
    emit('update:dateRange', localDateRange.value);
    emit('dateRangeChange');
}
</script>
